import { Avatar, SxProps, Typography } from "@mui/material";
import { useProfile } from "../../context/ProfileProvider/useProfile";

export type AvatarStyleType = {
    rounded: SxProps,
    normal: SxProps,
    column: SxProps,
    innerMenu: SxProps
}

export const avatarStyle: SxProps = {
    border: "1px solid #0000001A",
    borderRadius: "4px",
    marginRight: "10px",
    backgroundColor: "#E9EFF4",
    color: "#22638D",
    width: "36px",
    height: "36px"
}

export const avatarStyleInnerMenu: SxProps = {
    border: "1px solid #0000001A",
    borderRadius: "4px",
    backgroundColor: "#E9EFF4",
    color: "#22638D",
    width: "36px",
    height: "36px"
}


export const avatarRoundedStyle: SxProps = {
    width: "66px",
    height: "66px",
    backgroundColor: "#E9EFF4"
}

export const avatarColumnStyle: SxProps = {
    width: "26px",
    height: "26px",
    backgroundColor: "#22638D1A",
    borderRadius: "50%"
}

export const AvatarStyleTypeBuilder: AvatarStyleType = {
    normal: avatarStyle,
    rounded: avatarRoundedStyle,
    column: avatarColumnStyle,
    innerMenu: avatarStyleInnerMenu
}


interface IUserPicture {
    style: SxProps;
    source: string | undefined;
    username: string;
}

export const UserPicture: React.FunctionComponent<IUserPicture> = ({
    style,
    source,
    username
}) => {

    const profile = useProfile();
    
    return (
        <Avatar
            sx={style}
            src={source}
            >
            <Typography
                color="#22638D"
                fontSize="24px"
                fontWeight="600"
            >
                { username != undefined ? username![0] : "P" }
            </Typography>        
        </Avatar>
    )
}